import { forwardRef, useRef, useState } from "react";
import Form, { GroupItem, SimpleItem } from "devextreme-react/form";
import { useSelector } from "react-redux";
import { getLocalized } from "../../../../../redux/localization";
import { ApproveProduct, Product, ProductStatusDto } from "../../../types";
import { Button, Gallery, ScrollView } from "devextreme-react";
import { ApiResponse } from "../../../../../redux/base/types/saga";
import { BodyType, createRequest } from "../../../../../redux/base/request";
import { getApiParams } from "../../../../../redux/auth";
import notify from "devextreme/ui/notify";
import { imageUrl } from "../../../../../services/urls";
import { Modal } from "../../../../../components";
import ApproveProductModal from "./approveModal";
import UpdateProductModal from "./update-product-request";
const ProductDetailForm = forwardRef<
  any,
  { data?: Product; status?: ProductStatusDto[] }
>(({ data, status }, ref) => {
  const localize = useSelector(getLocalized);
  const { token, lang } = useSelector(getApiParams);
  const [show, setShow] = useState(false);
  const newData = useRef<ApproveProduct>({
    productId: data?.Id || "",
    message: "",
    approval: false,
  });
  const [scrollDatas] = useState({
    showScrollBarMode: "onScroll",
    pullDown: false,
    scrollByContent: true,
    scrollByThumb: true,
  });
  return (
    <>
      <Modal
        coverModal={false}
        width={"40%"}
        visible={show}
        onHiding={() => setShow(false)}
        title={localize.getString("productApproveForm")}
        height={"30%"}
        onSubmitClick={async () => {
          newData.current.productId = data?.Id || "";
          console.log(newData.current);
          const response: ApiResponse = await createRequest({
            method: "POST",
            url: "api/admin/products/approve-product",
            bodyType: BodyType.raw,
            token,
            body: newData.current,
            lang,
          });
          if (response.Status === 1) {
            notify(response.Message, "success");
            setShow(false);
          } else notify(response.Message, "error");
        }}
      >
        <ApproveProductModal data={newData.current}></ApproveProductModal>
      </Modal>
      <ScrollView
        scrollByContent={scrollDatas.scrollByContent}
        scrollByThumb={scrollDatas.scrollByThumb}
        showScrollbar={"onScroll"}
        bounceEnabled={scrollDatas.pullDown}
        height={600}
      >
        <form>
          {data?.Approved && (
            <div>
              <span
                style={{
                  fontWeight: 600,
                }}
              >
                Onaylayan Kullanıcı:
              </span>
              {data?.ApproverUser}
            </div>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBlockEnd: 20,
            }}
          >
            {data?.StatusId && (
              <UpdateProductModal status={status} statusId={data.StatusId} />
            )}
            <Button
              visible={data?.StatusId !== 2}
              text={localize.getString("approve")}
              hint={localize.getString("approved")}
              icon="check"
              type="success"
              stylingMode="contained"
              onClick={async () => {
                setShow(true);
              }}
            />
          </div>
          <Form
            ref={ref}
            key="id"
            labelLocation="left"
            formData={data}
            showColonAfterLabel={true}
          >
            <GroupItem colCount={2}>
              <GroupItem>
                <Gallery
                  id="gallery"
                  dataSource={data?.ProductImages?.map((x) => {
                    return imageUrl + x.ImageLocation;
                  })}
                  height={427}
                  slideshowDelay={5000}
                  loop={true}
                  showNavButtons={false}
                  showIndicator={true}
                />
              </GroupItem>
              <GroupItem>
                <SimpleItem
                  render={() => (
                    <span
                      style={{
                        fontWeight: 700,
                        fontSize: 24,
                        marginBlockStart: 30,
                      }}
                    >
                      {data?.Code}-{data?.Name}
                    </span>
                  )}
                />
                <SimpleItem
                  render={() => (
                    <span style={{ fontWeight: 400, fontSize: 13 }}>
                      {data?.Description}
                    </span>
                  )}
                />
                <SimpleItem
                  render={() => (
                    <span style={{ fontWeight: 400, fontSize: 13 }}>
                      <span style={{ fontWeight: 600, fontSize: 13 }}>
                        Kategori:{" "}
                      </span>
                      {"Yaşam Alanı"}
                    </span>
                  )}
                />
                <SimpleItem
                  render={() => (
                    <span style={{ fontWeight: 400, fontSize: 13 }}>
                      <span style={{ fontWeight: 600, fontSize: 13 }}>
                        {"Ürün Özellikleri"}:{" "}
                      </span>
                      {data?.ProductCardFeatures?.map((x) => (
                        <span>{x.Name}</span>
                      ))}
                    </span>
                  )}
                />
                <SimpleItem
                  render={() => (
                    <span style={{ fontWeight: 400, fontSize: 13 }}>
                      <span style={{ fontWeight: 600, fontSize: 13 }}>
                        Depozito Miktarı:{" "}
                      </span>
                      {data?.Deposit}₺
                    </span>
                  )}
                />

                <SimpleItem
                  render={() => (
                    <span style={{ fontWeight: 400, fontSize: 13 }}>
                      <span style={{ fontWeight: 600, fontSize: 13 }}>
                        Sigorta:{" "}
                      </span>
                      {data?.Insurance ? "Evet" : "Hayır"}
                    </span>
                  )}
                />
                <SimpleItem
                  render={() => (
                    <span style={{ fontWeight: 400, fontSize: 13 }}>
                      <span style={{ fontWeight: 600, fontSize: 13 }}>
                        Fiyat Gösterimi:{" "}
                      </span>
                      {data?.AskForPrice ? "Evet" : "Hayır"}
                    </span>
                  )}
                />
                <SimpleItem
                  render={() => (
                    <span style={{ fontWeight: 400, fontSize: 13 }}>
                      <span style={{ fontWeight: 600, fontSize: 13 }}>
                        Ürün Sahibi:{" "}
                      </span>
                      {data?.Account?.AccountName}
                      <i
                        className="dx-icon-info"
                        onClick={() =>
                          window.open("/#/account-details/" + data?.Account?.Id)
                        }
                        style={{
                          fontSize: 16,
                          cursor: "pointer",
                          marginInlineStart: 5,
                        }}
                      ></i>
                    </span>
                  )}
                />
              </GroupItem>
            </GroupItem>
          </Form>
        </form>
      </ScrollView>
    </>
  );
});

export default ProductDetailForm;
